// extracted by mini-css-extract-plugin
module.exports = {"headerImg":"AddCard_headerImg__u4xo9"};